import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { isVideoStation } from '@app/core/stations/helpers';
import {
  SocialExportPanorama,
  SocialExportPublishDropdown,
} from '../social-export-panorama';
import { useFragmentSocialUploadsQuery } from '../social-export-panorama/hooks/useFragmentSocialUploadsQuery';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { InfoTitle, QueryView } from '@mi-front/ui';
import ShareIcon from '@mui/icons-material/Share';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFragment } from '../../hooks/useFragment';

/**
 * Social export section: permission-gated, only for video stations. Shows section title, publish dropdown and uploads panorama.
 */
export function FragmentSocialPublishView() {
  const { fragment, station } = useFragment();
  const uploadsQuery = useFragmentSocialUploadsQuery(fragment.id);

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      {isVideoStation(station) ? (
        <QueryView query={uploadsQuery} inline>
          {() => (
            <Box>
              <Box
                mb={2}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                }}
              >
                <InfoTitle>
                  <ShareIcon fontSize="small" sx={{ mr: 0.5 }} />{' '}
                  <FormattedMessage
                    id="fragments.socialExport.sectionTitle"
                    defaultMessage="Redes Sociales"
                  />
                </InfoTitle>
                <SocialExportPublishDropdown uploadsByPlatform={uploadsQuery.data} />
              </Box>
              <SocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
            </Box>
          )}
        </QueryView>
      ) : (
        <></>
      )}
    </IfPermission>
  );
}
